export default __webpack_public_path__ + "static/media/Lanov-114-293-1-oin5-768x512.8c9ae5be.jpg";